module.exports = __webpack_public_path__ + "img/media-library-books.34f4db53.svg";